export const SET_BI_DATA = "SET_BI_DATA"
export const SET_BI_DATE = "SET_BI_DATE"
export const SET_BI_REGION_FILTERS = "SET_BI_FILTERS"
export const SET_BI_WORKER_FILTERS = "SET_BI_WORKER_FILTERS"
export const SET_BI_DEPARTMENT_FILTERS = "SET_BI_DEPARTMENT_FILTERS"
export const SET_INTEGRATOR = 'SET_INTEGRATOR'
export const SET_INTEGRATOR_LOADER = 'SET_INTEGRATOR_LOADER' 
export const SET_BI_ACTIVE_FILTERS = "SET_BI_ACTIVE_FILTERS"
export const SET_BI_DATA_ERROR = "SET_BI_DATA_ERROR"
export const SET_BI_SUBSCRIBES_REPORTS = "SET_BI_SUBSCRIBES_REPORTS"
export const SET_BI_LOADER = "SET_BI_LOADER"